import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PermisiuniActiuniComponent } from './permisiuni-actiuni.component';
import { AddPermisiuniActiuniComponent } from './add-permisiuni-actiuni/add-permisiuni-actiuni.component';
import { EditPermisiuniActiuniComponent } from './edit-permisiuni-actiuni/edit-permisiuni-actiuni.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';

@NgModule({
  declarations: [
    PermisiuniActiuniComponent, 
    AddPermisiuniActiuniComponent, 
    EditPermisiuniActiuniComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MaterialModule, 
  ],
  exports: [PermisiuniActiuniComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PermisiuniActiuniModule {}
